import React, { useContext, useEffect } from 'react';
import { renderToString } from 'react-dom/server';
import {removePrintOverlay, getConfiguration, getDatastoreWarName, getFormattedFullTimestamp} from '../../data/utils';
import { ShopReceiptPrinterContext } from './ShopReceiptPrinterContext';
import VoucherReceipt from './shop-receipts/VoucherReceipt';
import GrantReturnCashReceipt from './shop-receipts/GrantReturnCashReceipt';
import PaymentAndCancelTicketReceipt from './shop-receipts/PaymentAndCancelTicketReceipt';
import DetailedBalance from './shop-receipts/DetailedBalance';
import PickingReceipt from './shop-receipts/PickingReceipt';
import TransactionsLog from './shop-receipts/TransactionsLog';
import PhysicalRestVoucherPayment from './shop-receipts/PhysicalRestVoucherPayment';
import PosBalanceReceipt from './shop-receipts/PosBalanceReceipt';
import DailyShopDetailedBalance from './shop-receipts/DailyShopDetailedBalance'
import PosBalanceReport from './shop-receipts/PosBalanceReport';
import PosMonthlyCommReportReceipt from './shop-receipts/PosMonthlyCommReportReceipt';
import ReserveDepositForFinalUserReceipt from './shop-receipts/ReserveDepositForFinalUserReceipt';
import ThirdPartyVoucherPaymentReceipt from './shop-receipts/ThirdPartyVoucherPaymentReceipt';
import WithdrawRequestReceipt from './shop-receipts/WithdrawRequestReceipt';
import { useGetBase64Img} from './useGetBase64Img';
import ScratchCardPaymentReceipt from './shop-receipts/ScratchCardPaymentReceipt';
import AccountRechargeReceipt from './shop-receipts/AccountRechargeReceipt';
import CashoutReceipt from './shop-receipts/CashoutReceipt';
import { getTextAccountRechargeReceipt, getTextAccountRechargeByVoucherReceipt, getTextDetailedBalanceReceipt, getTextPaymentReceipt, getTextScratchCardPaymentReceipt, getTextCashoutReceipt, whitespaceBitmap, getTextCancelTicketReceipt } from './textual-tickets-utilities';
import { getEnv } from '../env';
import $ from 'jquery';
import RechargeAccountByVoucherReceipt from './shop-receipts/RechargeAccountByVoucherReceipt';

function ShopReceiptPrinter(props) {
	const shopReceiptPrinterContext = useContext(ShopReceiptPrinterContext);
	const receiptData = shopReceiptPrinterContext.receiptData;
	const receiptType = shopReceiptPrinterContext.receiptType;	
	// window.android = { printTicketApp : function(ticket){console.log(ticket)} , printBitmap : function(bm) {console.log(bm)}};

	const styleMarginZero = window.systemPrinterStyle? window.systemPrinterStyle : '<style> @page {margin:0;} </style>';
	
	function getStyleAndPrintScript(){
		return `
		<style>
		 	.hide{
				display:none!important;
			}
			.logo-container{
				margin-top:10px;
				/*text-align:center;*/
				display:flex;
				justify-content:center;
			}
			.logo-base {
				height: auto;
				width: auto;
				max-height:200px;
				max-width: 48%;
			}
			.aams-logo-img{
				margin-left:4%;
			}
			.just-this{
				max-width: 200px!important;				
			}
			
			.centerText {
				text-align:center;	
			}
			
			.error-container{
				text-align:center;
				margin-top:10px;
				margin-bottom:10px;
				font-weight:bold;
			}
			
			.width100x100{
				width:100%;
			}

			.width50x50{
				width:50%;
			}

			.width95x95{
				width:95%;
				margin-left: 2%;
			}

			.tableNoPageBreak {
				page-break-inside: avoid;
			}
			
			.uppercase{
				text-transform:uppercase;
			}
			.text-center{
				text-align:center;
			}
			
			.operationMonospace{
				font-size:15px;
				font-weight:bold;
				font-family:monospace;
			}
			
			.operation-title{
				font-size:22px;
				text-align:center;
				font-weight:bold;
				text-transform:uppercase;
				margin-top:10px;
				margin-bottom:2px;
			}
			
			.hr-line{
			   display: block;
			   -webkit-margin-before: 1.5em;
			   -webkit-margin-after: 1.5em;
			   -webkit-margin-start: -3em;
			   -webkit-margin-end: -3em;
			   border-style: inset;
			   border-width: 1px;
			   border-color: black;
			}
			.hr-line-no-margin-bottom{
			  display: block;
			   -webkit-margin-before: 1.5em;
			   -webkit-margin-after: 0.1em;
			   -webkit-margin-start: -3em;
			   -webkit-margin-end: -3em;
			   border-style: inset;
			   border-width: 1px;
			   border-color: black;
			}
			.hr-line-dashed{
			   display: block;
			   margin-top:10px;
			   margin-bottom:10px;
			   border-style: dashed;
			   border-width: 0.5px;
			   border-color: black;
			}
			.bold{
				font-weight:bold;
			}
			.reportBorderedOperatorName{
				border-style:solid;
				border-width:1px;
				font-size:15px;
				font-weight:bold;
				margin-bottom:4px;
				margin-top:4px;
				width:30%;
			}
			.qrcode-container{
				margin-top : 1%;
				margin-bottom:1%;
				display: grid;
    			justify-content: center;
			}
		
		</style>
		<script>
			window.PRINT_STATUS = "PENDING"; 
			(function() {
			    var beforePrint = function() {
			       window.PRINT_STATUS = "PENDING";
			    };
			    var afterPrint = function() {
			        window.PRINT_STATUS = "DONE";
			    };
			    if (window.matchMedia) {
			        var mediaQueryList = window.matchMedia(/print/g);
			        mediaQueryList.addListener(function(mql) {
			            if (mql.matches) {
			                beforePrint();
			            } else {
			                afterPrint();
			            }
			        });
			    }
			    window.onbeforeprint = beforePrint;
			    window.onafterprint = afterPrint;
			}());
			function printTicket() {
				this.print(); 
				return 0;
			}
		</script>
		`
	}
	const conf = getConfiguration();
	const aamsEnviroment = !conf.nas;
	const [customerLogo] = useGetBase64Img(`${getEnv('REACT_APP_API_DOMAIN')}/${getDatastoreWarName()}/content/images/customer-logo/${conf.logo}`, true);
	const [aamsLogo] = useGetBase64Img(`${getEnv('REACT_APP_API_DOMAIN')}/${getDatastoreWarName()}/content/images/loghi_aams.svg`, aamsEnviroment);
	const goOnWithPrint = (customerLogo && (!aamsEnviroment || aamsLogo));

	useEffect(() =>{
		var ev = new $.Event('remove'), orig = $.fn.remove;
		$.fn.remove = function() {
			$(this).trigger(ev);
			return orig.apply(this, arguments);
		}

		return () => {
			$.fn.remove = function() {
				return orig.apply(this, arguments);
			}
		}
	}, []);
	

	useEffect(() =>{
		if(goOnWithPrint){
			const printTextTicketApk = window.android?.printTicketApp;
			const showPreview = receiptType === 'detailedBalance' && conf.rs.dbp && window.setModalPrinterPreview;
			if(!printTextTicketApk){
				$("#receipt-print-ticket").remove();
				let htmlReceipt = '';
				switch (receiptType) {
					case 'voucher': htmlReceipt = renderToString(<VoucherReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} cashierNumber={window.NUM_CASSA}  voucherData={receiptData} />); break;
					case 'grantCash': htmlReceipt = renderToString(<GrantReturnCashReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} grantCashData={receiptData} />); break;
					case 'returnCash': htmlReceipt = renderToString(<GrantReturnCashReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} returnCashData={receiptData} />); break;
					case 'paymentTicket': htmlReceipt = renderToString(<PaymentAndCancelTicketReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} paymentData={receiptData} />); break;
					case 'cancelTicket': htmlReceipt = renderToString(<PaymentAndCancelTicketReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} cancelData={receiptData} />); break;
					case 'detailedBalance' : htmlReceipt = renderToString(<DetailedBalance customerLogo={customerLogo} aamsLogo={aamsLogo} detailedBalanceData={receiptData} />); break;
					case 'posBalance' : htmlReceipt = renderToString(<PosBalanceReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} posBalanceData={receiptData} />); break;
					case 'pickingReceipt' : htmlReceipt = renderToString(<PickingReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;
					case 'transactionsLog' : htmlReceipt = renderToString(<TransactionsLog customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;
					case 'physicalRestVoucherPayment' : htmlReceipt = renderToString(<PhysicalRestVoucherPayment customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;
					case 'dailyShopDetailedBalance' : htmlReceipt = renderToString(<DailyShopDetailedBalance customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;
					case 'posBalanceReport' : htmlReceipt = renderToString(<PosBalanceReport customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;
					case 'monthlyCommissionReport' : htmlReceipt = renderToString(<PosMonthlyCommReportReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;
					case 'reserveDepositForFinalUserReceipt' : htmlReceipt = renderToString(<ReserveDepositForFinalUserReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;
					case 'thirdPartyVoucherPaymentReceipt' : htmlReceipt = renderToString(<ThirdPartyVoucherPaymentReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;
					case 'withdrawRequestReceipt' : htmlReceipt = renderToString(<WithdrawRequestReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;
					case 'scratchCardPaymentReceipt' : htmlReceipt = renderToString(<ScratchCardPaymentReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;			
					case 'accountRechargeReceipt' : htmlReceipt = renderToString(<AccountRechargeReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;			
					case 'cashoutReceipt' : htmlReceipt = renderToString(<CashoutReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;			
					case 'rechargeVoucherReceipt' : htmlReceipt = renderToString(<RechargeAccountByVoucherReceipt customerLogo={customerLogo} aamsLogo={aamsLogo} data={receiptData} />); break;			

					default: htmlReceipt = '';
				}
				
				const htmlCodeWithScript = (window.XSocket? styleMarginZero : '')  + getStyleAndPrintScript() + htmlReceipt;
				const iframe = document.createElement('iframe');
				$(iframe).attr({
					style : "height: 0px; margin: 0px; position: absolute; z-index: 1000000; border: solid 0px transparent; top: 0; left: 0;",
					id : "receipt-print-ticket",
					src : "#" + new Date().getTime()
				});
				iframe.doc = null;
				iframe.doc = iframe.contentDocument ? iframe.contentDocument : (iframe.contentWindow ? iframe.contentWindow.document : iframe.document);
				iframe.autofocus = true;
				// HTML INJECT!
				iframe.srcdoc = htmlCodeWithScript;
		
				if(shopReceiptPrinterContext.showHtml){
					// I show the hidden frame if the developer need to do that
					$(iframe).css({
						"position" : "absolute",
						"z-index" : 2000,
						"height" : "20000px",
						"background-color" : "white"
					})
				}
				else{
					if(showPreview){
						$(iframe).css({
							"position" : "relative",
							"height" : "400px",
							"background-color" : "white",
							"width":"300px"
						})					
					}
					iframe.addEventListener('load', function() {
						try {
							console.debug("IFRAME TO PRINT " + JSON.stringify(receiptData) + " MOUNTED " + getFormattedFullTimestamp());		
						}catch(err) {
							console.error(err);
						}		            
						const cw = iframe.contentWindow;
						cw.focus();
						if(!showPreview){
							cw.printTicket();	// invoking the window.print in the iframe						
						}
						let unlockInterval = setInterval(() =>{
							try{
								if(iframe.contentWindow.PRINT_STATUS === 'DONE'){
									// print done! close everything
									clearInterval(unlockInterval);
									console.log("PRINT DONE!");
									removePrintOverlay();
									$("#receipt-print-ticket").remove();
									shopReceiptPrinterContext.setPrintDone();
									if(cw.previewCallback){
										cw.previewCallback();
									}
								}
							}
							catch(e){
								clearInterval(unlockInterval);
								console.error("PRINT EXCEPTION: " + e);
								console.error("Print dialog closed");
								
								shopReceiptPrinterContext.setPrintDone();
							}
		
						},150);	
					});
				}
				if(showPreview){
					shopReceiptPrinterContext.setPrintDone();
					window.setModalPrinterPreview(iframe);
				}
				else{
				// on append finished, the frame 'on load' event listener will be triggered
					document.body.appendChild(iframe);		
				}
				$(iframe).bind('remove', function(e) {
					try {
						console.debug("IFRAME TO PRINT " + JSON.stringify(receiptData) + " UNMOUNTED " + getFormattedFullTimestamp());		
					}catch(err) {
						console.error(err);
					}
				});						

					
			}
			else {
				let textReceipt = '';
				switch (receiptType) {
					case 'scratchCardPaymentReceipt': textReceipt = getTextScratchCardPaymentReceipt(receiptData); break;
					case 'accountRechargeReceipt': textReceipt = getTextAccountRechargeReceipt(receiptData); break;
					case 'detailedBalance': textReceipt = getTextDetailedBalanceReceipt(receiptData); break;
					case 'paymentTicket' : textReceipt = getTextPaymentReceipt(receiptData); break;
					case 'cancelTicket' : textReceipt = getTextCancelTicketReceipt(receiptData); break;
					case 'cashoutReceipt' : textReceipt = getTextCashoutReceipt(receiptData); break;
					case 'rechargeVoucherReceipt' : textReceipt = getTextAccountRechargeByVoucherReceipt(receiptData); break;
					default: textReceipt = '';
				}
				function print(){
					const bitmapLogo = customerLogo?.split('data:image/png;base64,')[1];
					if(bitmapLogo){
						window.android.printBitmap(bitmapLogo);
					}
					window.android.printTicketApp(textReceipt, false); // true is to print html
					if(window.android.printQrCode && receiptType === 'rechargeVoucherReceipt'){
						window.android.printQrCode(receiptData.id);
					} 
					window.android.printBitmap(whitespaceBitmap);
					shopReceiptPrinterContext.setPrintDone();
				
				}
				if(showPreview){
					shopReceiptPrinterContext.setPrintDone();
					window.setModalPrinterPreview(textReceipt, print);
				}
				else {
					print();
				}
			}
		}
	
	}, [shopReceiptPrinterContext.receiptData, goOnWithPrint]);
	

	return null;
}

export default ShopReceiptPrinter;